export enum AddressType {
  Billing = "BILLING",
  Shipping = "SHIPPING",
  ShippingRelayPoint = "SHIPPING_RP",
}
